import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AppService } from '@irb/app.service';
import { IrbClientsService } from '@irb/irb-clients/irb-clients.service';
import { IrbClientsEvents, IrbAppEvents } from '@irb-common/events';
import { IExternalAccounts } from '@irb/irb-clients/irb-clients.model';
import { UtilityService } from '@irb-common/services/utility.service';
import {IAlertDialogData} from "@irb/app.model";

@Component({ standalone: false,
  selector: 'irb-import-external-accounts-dialog',
  templateUrl: './import-external-accounts-dialog.component.html',
  styleUrls: ['./import-external-accounts-dialog.component.scss','../../irb-common/styles/dialog.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ImportExternalAccountsDialogComponent implements OnInit {
  _file: any;
  hasFile: boolean = false;
  isValidFile: boolean = false;
  invalidFileErrorHeader: string;
  invalidFileErrorMessage: string;
  errorMessage: string;
  updateStatusCount = 0;
  progressTimer: any = null;
  isUiTest = false;

  constructor(
    public dialogRef: MatDialogRef<ImportExternalAccountsDialogComponent>,
    public as: AppService,
    public cs: IrbClientsService,
    private util: UtilityService
  ) { }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }

  onFileChange(event: any) {
    this.file = event.target.files[0];
    this.hasFile = this.isValidFile = true;
    if (!this.file.name.endsWith('.csv')) {
      this.isValidFile = false;
      this.invalidFileErrorHeader = "Invalid file format.";
      this.invalidFileErrorMessage = "Extension type must be \".csv\"";
    }
    if (this.as.maxFileUploadSizeExceeded(this.file)) {
      this.triggerMaxFileUploadSizeExceededError();
    }
  }

  private triggerMaxFileUploadSizeExceededError() {
    this.isValidFile = false;
    this.invalidFileErrorHeader = "Invalid file size.";
    this.invalidFileErrorMessage = "File size exceeds 50MB limit.";
  }

  submitFile() {
    const f = new FormData();
    f.append('ImportExternalAccounts0', this.file, this.file.name);
    this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
    this.cs.importExternalAccountsAsync(f).subscribe((response: any) => {
      this.updateStatusCount = 0;
      if (this.progressTimer) clearTimeout(this.progressTimer);
      this.updateStatusCount = 0;
      if (response.responseUtilityMap) {
        this.actionStatusCheckIntervalStart(response.responseUtilityMap.statusId);
      }
    }, () => {
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
    });
  }

  actionStatusCheckIntervalStart(statusId: any) {
    this.cs.asyncStatusCheck(statusId).subscribe((statusResponse: any) => {
      if (statusResponse.responseStatus === "SUCCESS") {
        const responseData = statusResponse.responseData;
        let reqStatus = 'FAILED';
        if (statusResponse.responseUtilityMap && statusResponse.responseUtilityMap.requestStatus) {
          reqStatus = statusResponse.responseUtilityMap.requestStatus.trim().toUpperCase();
        }

        if (reqStatus === 'STARTED' || reqStatus === 'NEW' || reqStatus === 'IN_PROGRESS') {
          this.updateProgressBarStatus(statusId);
        }

        if (reqStatus === 'COMPLETED') {
          this.proceedWithSubmitResponse(responseData);
        }

        if (reqStatus === 'FAILED' || reqStatus === null) {
          this.actionStatusCheckFailed();
        }
      } else {
        this.actionStatusCheckFailed();
      }
    }, () => {
      this.close();
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      if (this.progressTimer) clearTimeout(this.progressTimer);
    });
}

updateProgressBarStatus(statusId: any) {
  let timeout = (this.updateStatusCount > 10) ? 8000 : (this.updateStatusCount > 2) ? 3000 : 1500;
  if (this.isUiTest)
    timeout = 0;
  this.updateStatusCount++;
  this.progressTimer = setTimeout(() => {
    this.actionStatusCheckIntervalStart(statusId);
  }, timeout);
}

actionStatusCheckFailed() {
  this.close();
  this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
  this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
    dType: 'ERROR',
    dTitle: '',
    dProceedBtnLabel: '',
    msg: 'An error occurred processing your request.',
    onProceed: () => {
    }
  } as IAlertDialogData);
}

proceedWithSubmitResponse(res: any) {
  if (this.progressTimer) clearTimeout(this.progressTimer);
  this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
  const response = JSON.parse(res.substring(res.indexOf('<textarea>') + 10, res.indexOf('</textarea>'))) as IExternalAccounts;
  if(response.status && response.status === "fail") {
    if (response.message)
      this.errorMessage = response.message;
    else
      this.isValidFile = false;
    return;
  }

  const hasValidRecords = (response.validRecords && response.validRecords.length > 0);
  const hasInvalidRecords = (response.invalidRecords && response.invalidRecords.length > 0);
  const hasdeletedExtAccts = (response.deletedExtAccts && response.deletedExtAccts.length > 0);

  if (!hasValidRecords && !hasInvalidRecords && !hasdeletedExtAccts) {
    this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
      severity: 'warn',
      summary: 'Import External Accounts',
      detail: 'The import completed without any accounts being imported.'
    });
  } else if(!hasInvalidRecords && !hasdeletedExtAccts) {
    this.as.fireEvent(IrbClientsEvents. IMPORT_EXTERNAL_ACCOUNTS_VALIDATE, response);
  } else {
    this.as.fireEvent(IrbClientsEvents.SHOW_IMPORT_EXTERNAL_ACCOUNTS_RESULT, response);
  }
  this.close()
}

  get file(): any {
    return this._file;
  }

  set file(f: any) {
    this._file = f;
  }
}
